/* Форматирование чисел, дат и склонений. */

const nf = new Intl.NumberFormat('ru-RU');

export const num = (v) => nf.format(Math.round(v || 0));
export const money = (v) => `${num(v)} ₽`;

/** plural(5, 'товар', 'товара', 'товаров') → 'товаров' */
export function plural(n, one, few, many) {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (last > 1 && last < 5) return few;
  if (last === 1) return one;
  return many;
}

export const goodsLabel = (n) => `${n} ${plural(n, 'товар', 'товара', 'товаров')}`;
export const reviewsLabel = (n) => `${num(n)} ${plural(n, 'отзыв', 'отзыва', 'отзывов')}`;
export const ratingsLabel = (n) => `${num(n)} ${plural(n, 'оценка', 'оценки', 'оценок')}`;

const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

const parse = (value) => {
  if (!value) return null;
  const d = new Date(String(value).replace(' ', 'T'));
  return Number.isNaN(+d) ? null : d;
};

export function formatDate(value) {
  const d = parse(value);
  return d ? `${d.getDate()} ${MONTHS[d.getMonth()]}` : '';
}

export function formatDateFull(value) {
  const d = parse(value);
  if (!d) return '';
  const time = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${time}`;
}

export function formatDateShort(value) {
  const d = parse(value);
  if (!d) return '';
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** Окно доставки: (2, 4) → «31 августа — 2 сентября» */
/*
Окно доставки.

Дату нельзя считать от часов того, кто рисует: сервер и браузер стоят в разных
зонах, а страница вдобавок живёт в кеше до десяти минут. Отрисованная в 23:59
строка доедет до покупателя уже в новых сутках, и текст разойдётся с тем, что
нарисует браузер, — React забракует разметку.

Поэтому точка отсчёта приходит снаружи: сервер кладёт свою метку времени в
данные страницы, и обе стороны считают от неё одинаково.
*/
export function deliveryWindow(daysMin, daysMax, now = Date.now()) {
  if (daysMin == null) return '';
  const from = new Date(now + daysMin * 86400000);
  const to = new Date(now + daysMax * 86400000);
  const f = `${from.getDate()} ${MONTHS[from.getMonth()]}`;
  const t = `${to.getDate()} ${MONTHS[to.getMonth()]}`;
  return f === t ? f : `${f} — ${t}`;
}

export const ORDER_STATUS = {
  new: 'Принят, собираем',
  packed: 'Собран',
  sent: 'Передан в СДЭК',
  done: 'Выдан',
  canceled: 'Отменён',
};

/** Транслитерация для автогенерации слага в админке. */
const TRANSLIT = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i',
  й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't',
  у: 'u', ф: 'f', х: 'h', ц: 'c', ч: 'ch', ш: 'sh', щ: 'sch', ъ: '', ы: 'y', ь: '',
  э: 'e', ю: 'yu', я: 'ya',
};

export function slugify(value) {
  return String(value || '')
    .toLowerCase()
    .split('')
    .map((ch) => (TRANSLIT[ch] ?? ch))
    .join('')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}
